import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { pluck, pluckNumber, parseUnsafeString, POSITION_START, POSITION_END, POSITION_TOP, POSITION_BOTTOM, POSITION_MIDDLE, POSITION_RIGHT, preDefStr, BLANKSTRING, setLineHeight, getFirstValue, pluckFontSize, chartPaletteStr, TESTSTR, crispBound, extend2, convertColor, getFirstColor } from '../../../../../../fc-core/src/lib';
import { ComponentInterface } from '../../../../../../fc-core/src/component-interface';
import LegendItem from './legend-item';
import { addDep } from '../../../../../../fc-core/src/dependency-manager';
import { Scroller } from '../../../../../../fc-core/src/toolbox';
import legendAnimation from './index.animation';
import { priorityList } from '../../../../../../fc-core/src/schedular';

var UNDEF,
    TEXT_ANCHOR_MAP = {
  left: POSITION_START,
  right: POSITION_END,
  center: POSITION_MIDDLE
},
    math = Math,
    mathMin = math.min,
    mathMax = math.max,
    mathFloor = math.floor,
    mathCeil = math.ceil,
    COMMA = ',',
    NONE = 'none',
    NORMAL = preDefStr.NORMAL,
    BOLD = preDefStr.BOLD,
    noneStr = preDefStr.noneStr,
    styleValueMap = {
  fontWeight: {
    1: BOLD,
    0: NORMAL
  },
  fontStyle: {
    1: 'italic',
    0: NORMAL
  },
  textDecoration: {
    1: 'underline',
    0: noneStr
  }
},
    handlers = function handlers(a) {
  var b, c;
  return {
    dragstart: function dragstart() {
      b = a.config.xL || a.config.xPos, c = a.config.yL || a.config.yPos;
    },
    dragmove: function dragmove(d) {
      var e,
          f,
          g = d.originalEvent.data[0],
          h = d.originalEvent.data[1],
          i = a.config,
          j = a.getFromEnv('chartConfig'),
          k = (i.borderWidth || 0) + 2;
      e = mathMin(mathMax(b + g, k), j.width - i.width - k), f = mathMin(mathMax(c + h, k), j.height - i.height - k), i.xPos = i.xL = e, i.yPos = i.yL = f, a.addJob('draw', a.dragDraw, priorityList && priorityList.draw);
    }
  };
};

addDep({
  name: 'legendAnimation',
  type: 'animationRule',
  extension: legendAnimation
});

var Legend =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(Legend, _ComponentInterface);

  function Legend() {
    var _this;

    _classCallCheck(this, Legend);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Legend).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a._stateCosmetics = {}, a._legendState = [], a.dragDraw = function () {
      a.draw();
    }, a.drawScroll = function () {
      a.createItemGroup();
    }, a.config.handlers = handlers(a);
    return _this;
  }

  _createClass(Legend, [{
    key: "createItem",
    value: function createItem(a) {
      var b,
          c = this;
      return b = new LegendItem(), c.attachChild(b, 'legendItem'), b.setLinkedItem('owner', a), b.addEventListener('mouseover', function () {
        b.setLegendState('hover', !0);
      }), b.addEventListener('mouseout', function () {
        b.removeLegendState('hover');
      }), b.getId();
    }
  }, {
    key: "getItem",
    value: function getItem(a) {
      var b = this,
          c = b.getChildren().legendItem;
      if (!(a !== UNDEF)) return !1;else if (c) for (var _b = 0; _b < c.length; _b++) {
        if (c[_b].getId() === a) return c[_b];
      }
    }
  }, {
    key: "getSortedLegendItems",
    value: function getSortedLegendItems() {
      var a,
          b,
          c = this,
          d = c.getChildren('legendItem') || [],
          e = c.config.reverselegend,
          f = {},
          g = [];

      for (a = 0, b = d.length; a < b; a++) {
        d[a].config.index === UNDEF ? f[b + a] = d[a] : f[d[a].config.index] = d[a];
      }

      return Object.keys(f).sort(function (a, b) {
        return e ? b - a : a - b;
      }).forEach(function (a) {
        g.push(f[a]);
      }), g;
    }
  }, {
    key: "disposeItem",
    value: function disposeItem(a) {
      var b = this,
          c = b.getItem(a);
      c && c.remove();
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'legend';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'legend';
    }
  }, {
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      _get(_getPrototypeOf(Legend.prototype), "__setDefaultConfig", this).call(this);

      var a = this.config;
      a.enabled = !0, a.symbolWidth = 12, a.borderRadius = 1, a.lastScrollPos = 0, a.oriSymbolPadding = 3, a.textPadding = 4, a.scrollY = 0, a.backgroundColor = '#FFFFFF', a.initialItemX = 0, a.title = {
        text: BLANKSTRING,
        x: 0,
        y: 0,
        padding: 2
      }, a.scroll = {}, a.itemStyle = {};
    }
  }, {
    key: "createLegendGroup",
    value: function createLegendGroup() {
      var a,
          b = this,
          c = b.config,
          d = b.getFromEnv('chart'),
          e = d.config,
          f = b.getFromEnv('animationManager'),
          g = .5 * (c.borderWidth || 0) + 2,
          h = b.getContainer('legendGroup');
      c.xL && (c.xL = mathMin(mathMax(c.xL, g), e.width - c.width - g)), c.yL && (c.yL = mathMin(mathMax(c.yL, g), e.height - c.height - g)), a = f.setAnimation({
        el: h || 'group',
        attr: {
          name: 'legendGroup',
          transform: ['T', c.xL || c.xPos, c.yL || c.yPos]
        },
        container: d.getChildContainer('legendGroup'),
        component: b
      }), h || b.addContainer('legendGroup', a);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.createLegendGroup(), this.drawLegendBox(), this.createItemGroup(), this.drawCaption(), this.createScrollGroup(), this.decideScroll();
    }
  }, {
    key: "decideScroll",
    value: function decideScroll() {
      var a = this,
          b = a.config,
          c = b.scroll.enabled;
      c ? this.createScrollBar() : b.hasScroll && (a.getChildren('legendScrollBar')[0].remove(), b.hasScroll = !1);
    }
  }, {
    key: "createItemGroup",
    value: function createItemGroup() {
      var a,
          b = this,
          c = b.getFromEnv('animationManager'),
          d = b.getContainer('legendGroup'),
          e = b.getChildContainer('itemGroup'),
          f = pluckNumber(b.config.padding, 4),
          g = Math.max(b.config.height - f, 0),
          h = COMMA + b.config.width + COMMA + g;
      return a = c.setAnimation({
        el: e || 'group',
        attr: {
          name: 'item',
          transform: ['T', 0, b.config.scrollY || 0]
        },
        container: d,
        component: b
      }), e || b.addChildContainer('itemGroup', a), b.config.scroll.enabled ? a.attr({
        "clip-rect": '0,' + .5 * f + h
      }) : a.attr({
        "clip-rect": null
      }), a;
    }
  }, {
    key: "createScrollGroup",
    value: function createScrollGroup() {
      var a = this,
          b = a.getFromEnv('animationManager'),
          c = a.getChildContainer('scrollGroup'),
          d = a.getContainer('legendGroup');
      a.config.scroll.enabled && !a.getGraphicalElement('scrollerContainer') && a.addGraphicalElement('scrollerContainer', b.setAnimation({
        el: c || 'group',
        attr: {
          name: 'scrollGroup'
        },
        container: d,
        component: a,
        label: 'scroller'
      }));
    }
  }, {
    key: "createScrollBar",
    value: function createScrollBar() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g = Math.max,
          i = this,
          j = i.config,
          k = i.getFromEnv('chart-attrib'),
          l = i.getChildren('legendScrollBar') && i.getChildren('legendScrollBar')[0],
          m = j.borderWidth || 0,
          n = pluckNumber(j.padding, 4),
          o = j.width,
          p = j.height;
      a = {
        conf: {
          isHorizontal: !1
        },
        handler: {
          scroll: function scroll(a) {
            j.lastScrollPos = a, j.scrollY = (c - j.totalHeight) * a, i.addJob('scrollDraw', i.drawScroll, priorityList && priorityList.draw);
          },
          mousedown: function mousedown(a) {
            a.preventDefault(), a.stopPropagation();
          }
        }
      }, k.legendscrollbgcolor && (a.conf.color = convertColor(k.legendscrollbgcolor)), l || (l = i.attachChild(new Scroller(), 'legendScrollBar'), this.config.hasScroll = !0), l.configure(a.conf), l.attachEventHandlers(a.handler), b = l.config, c = g(p - n, 0), d = o - 10 + .5 * n - m, e = .5 * m, f = g(p - m, 0), b.scrollRatio = (c + n) / j.totalHeight, b.startPercent = 0, b.scrollPosition = j.lastScrollPos, b.parentLayer = i.getChildContainer('scrollGroup'), l.setDimension({
        x: d,
        y: e,
        height: f
      });
    }
  }, {
    key: "drawCaption",
    value: function drawCaption() {
      var a,
          b,
          c,
          d,
          e = this,
          f = e.getChildContainer('itemGroup'),
          g = e.getGraphicalElement('caption'),
          h = this.getFromEnv('animationManager'),
          i = this.config,
          j = pluckNumber(i.padding, 4),
          k = i.scroll.enabled,
          l = i.width;

      if (i.title && i.title.text !== BLANKSTRING && i.validLegendItem) {
        switch (i.title.align) {
          case POSITION_START:
            c = j;
            break;

          case POSITION_END:
            c = l - j - (k ? 10 : 0);
            break;

          default:
            c = .5 * l;
        }

        b = i.title.style, a = {
          text: i.title.text,
          title: i.title.originalText || BLANKSTRING,
          x: c,
          y: j,
          fill: i.title.style.color,
          direction: i.textDirection,
          "line-height": b.lineHeight,
          "vertical-align": POSITION_TOP,
          "text-anchor": i.title.align,
          opacity: 1
        }, d = {
          "font-weight": b.fontWeight,
          "font-style": b.fontStyle,
          "font-family": b.fontFamily,
          "font-size": b.fontSize
        }, g && g.show(), g ? h.setAnimation({
          el: g,
          attr: a,
          component: e
        }) : (g = h.setAnimation({
          el: 'text',
          attr: a,
          component: e,
          container: f
        }), g = this.addGraphicalElement('caption', g), g.css(d)), e.getFromEnv('toolTipController').enableToolTip(g, i.title.originalText);
      } else g && h.setAnimation({
        el: g,
        component: e,
        doNotRemove: !0,
        callback: function callback() {
          g.hide();
        }
      });
    }
  }, {
    key: "drawLegendBox",
    value: function drawLegendBox() {
      var a,
          b = this,
          c = this.getFromEnv('animationManager'),
          d = b.config,
          e = b.getContainer('legendGroup'),
          f = d.width,
          g = b.getGraphicalElement('box'),
          h = d.height,
          i = d.borderRadius,
          j = d.backgroundColor,
          k = d.borderColor,
          l = d.borderAlpha,
          m = d.backgroundAlpha,
          n = d.borderWidth || 0;
      return a = c.setAnimation({
        el: g || 'rect',
        attr: {
          x: 0,
          y: 0,
          width: f,
          height: h,
          r: i,
          stroke: k,
          "stroke-width": n,
          fill: j || NONE,
          "stroke-opacity": l / 100,
          "fill-opacity": m / 100,
          cursor: d.legendAllowDrag ? 'move' : 'default'
        },
        container: e,
        component: b,
        label: 'legendGroup'
      }), g || (b.addGraphicalElement('box', a), a.shadow(d.shadow)), a;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.getFromEnv('chart'),
          i = h.config,
          j = g.config,
          k = i.height - i.canvasBottom,
          l = i.canvasLeft,
          m = i.canvasWidth,
          n = j.chartMarginLeft || 0,
          o = j.chartMarginRight || 0,
          p = j.chartMarginBottom || 0,
          q = i.actionBarHeight || 0,
          r = j.actualCanvasMarginLeft || 0,
          s = i.actualCanvasMarginBottom || 0,
          t = i.actualCanvasMarginRight || 0,
          u = j.alignLegendWithCanvas,
          v = i.height,
          w = i.canvasTop,
          x = j.width || 0,
          y = j.height || 0,
          z = i.borderWidth,
          A = i.oriCanvasLeft,
          B = i.oriTopSpace,
          C = i.oriBottomSpace,
          D = 0,
          E = 0,
          F = j.borderWidth || 0,
          G = j.legendPos;
      return G === POSITION_RIGHT && (j.align = POSITION_RIGHT, j.verticalAlign = POSITION_MIDDLE, f = j.layout = 'vertical'), f ? (a = i.width - o - t - x - z, D = pluckNumber(B, w), E = pluckNumber(C, k), b = D + .5 * (v - E - D - y) + (j.y || 0)) : (d = i.width - (n + r + (o + t)), e = u ? m - x : d - x, c = u ? pluckNumber(A, l) : n + r, a = c + e / 2, b = v - y - s - p - q), crispBound(a, b, x, y, F);
    }
  }, {
    key: "setTranslation",
    value: function setTranslation(a, b) {
      var c = this,
          d = c.config;
      d._translateX = a, d._translateY = b, d.translate = 't' + a + ',' + b;
    }
  }, {
    key: "allocatePosition",
    value: function allocatePosition() {
      var a,
          b = this,
          c = b.config;
      a = c.translate ? crispBound(c._translateX, c._translateY, c.width, c.height, c.borderWidth) : b.getPosition(), c.xPos = a.x, c.yPos = a.y, c.width = a.width, c.height = a.height;
    }
  }, {
    key: "_manageLegendPosition",
    value: function _manageLegendPosition(a) {
      var b,
          c = this,
          d = c.config,
          e = d.legendPos;
      return d.padding = 4, d.textPadding = 4, b = e === POSITION_RIGHT ? c._placeLegendBlockRight(a) : c._placeLegendBlockBottom(a), b;
    }
  }, {
    key: "setDimension",
    value: function setDimension(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          z,
          A,
          B = this,
          C = this.config,
          D = B.getSortedLegendItems(),
          E = D.length,
          F = a.width,
          G = a.height,
          H = 2 * G,
          I = 0,
          J = 0,
          K = 0,
          L = 0,
          M = 0,
          N = 0,
          O = 0,
          P = 0,
          Q = [],
          R = !1,
          S = C.padding,
          T = C.textPadding,
          U = B.getFromEnv('smartLabel'),
          V = B.getStateCosmetics('default'),
          W = parseInt(V.text['font-size'], 10) || 10,
          X = 0,
          Y = 0,
          Z = C.title,
          $ = Z.padding,
          _ = C.minimiseWrappingInLegend,
          aa = C.legendPadding,
          ba = C.legendScale,
          ca = C.alignLegendWithCanvas,
          da = C.numColumns,
          ea = C.oriSymbolPadding,
          fa = F;

      for (q = {
        width: 2 * S,
        height: 2 * S
      }, p = W + 1, 0 >= p && (p = 1), F -= 2 * S, p *= ba, ea *= ba, p = mathMin(p, F), 0 >= p && (ea = p = 0), C.symbolWidth = p, C.textPadding = 4, C.legendHeight = o = p + 2 * ea, C.rowHeight = g = mathMax(parseInt(V.text['line-height'], 10) || 12, o), f = T + ea + S, U.setStyle(extend2({}, V.text)), r = U.getOriSize(TESTSTR).height, h = aa + C.borderWidth / 2 + 1, h = mathMin(h, G - r - 8), aa = .05 * g, C.initialItemY = 0, C.initialItemX = 0, s = 0; s < E; s += 1) {
        if (e = D[s], b = e.config || (e.config = {}), c = b, d = b.name = parseUnsafeString(c.label), d === BLANKSTRING || 0 === c.enabled || !1 === c.enabled || e.getState('removed')) {
          b.enabled = 0;
          continue;
        } else b.enabled = 1;

        K += 1, x = !0, y = U.getOriSize(d), I = mathMax(I, y.width), N = mathMax(N, mathMin(y.height, H)), J += y.width;
      }

      if (C.validLegendItem = x, L = J / K, A = o + aa + T + ea + 2 * S, J += A * K, C.x = !ca && J > fa ? 0 : C.x, x) {
        for (L += A, I += A, 0 < da && K < da && (da = K), J <= F && (0 >= da || da === K) ? (da = K, M = L = J / K, R = !0, N > g && (P = (N - g) / 2, g = N)) : 0 < da && (M = F / da) > L ? M > I && (M = I) : F > I && (_ || 1.5 * L > I) ? (da = mathFloor(F / I), K < da && (da = K), M = I) : F >= 2 * L ? (da = mathFloor(F / L), K < da && (da = K), M = mathFloor(F / da), M > I && (M = I)) : (da = 1, M = F), C.itemWidth = M, k = mathCeil(M - A), 0 > k && (ea = k = T = 0), C.symbolPadding = ea, C.textPadding = T, C.width = M * da - aa, Z.oriText !== BLANKSTRING && (U.setStyle(Z.style), y = U.getSmartText(Z.oriText, F, H), Z.text = y.text, y.tooltext && (Z.originalText = y.tooltext), n = y.width + 2 * S, C.width < n && (C.initialItemX = (n - C.width) / 2, C.width = n), C.initialItemY = O = y.height + $), U.setStyle(extend2({}, V.text)), s = 0; s < E; s += 1) {
          if (e = D[s], b = e.config, 0 !== b.enabled) {
            if (0 === k && (Q[Y] = !0, b.name = BLANKSTRING, t = 1, v = parseInt(Y / da, 10), u = Y % da, b._legendX = u * M, b._legendY = v * g + 2 * S, b._legendH = t * g, b._totalWidth = p + ea), R) y = U.getOriSize(b.name), y.height < g && (b._legendTestY = (g - y.height) / 2), b._markerYGutter = P, b._legendX = X, b._legendY = 2 * S, b._legendH = g, b._totalWidth = p + f + y.width, X += y.width + A;else {
              for (y = U.getSmartText(b.name, k, H), b.name = y.text, y.tooltext && (b.originalText = y.tooltext); !0 === Q[Y];) {
                Y += 1;
              }

              for (l = y.height / g, m = Y, t = 0; t < l; t += 1, m += da) {
                Q[m] = !0;
              }

              y.height < g && (b._legendTestY = (g - y.height) / 2), v = parseInt(Y / da, 10), u = Y % da, b._legendX = u * M, b._legendY = v * g + 2 * S, b._legendH = t * g, b._totalWidth = p + f + y.width;
            }
            Y++;
          }
        }

        w = R ? 1 : mathCeil(Q.length / da), q.height += w * g + O, C.height = C.totalHeight = q.height, C.rowHeight = g, C.legendNumColumns = da, C.height - 2 * ea > G ? (C.height = G, z = C.scroll || (C.scroll = {}), z.enabled = !0, z.flatScrollBars = C.flatScrollBars, z.scrollBar3DLighting = C.scrollBar3DLighting, C.width = C.width + 12 > F ? C.width : C.width + 12) : C.scroll.enabled = !1, h += C.height, C.isActive = !0, C.enabled = !0;
      } else C.enabled = !1, C.width = 0, h = 0;

      return {
        width: F,
        height: h
      };
    }
  }, {
    key: "_placeLegendBlockBottom",
    value: function _placeLegendBlockBottom(a) {
      var b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.getFromEnv('chart'),
          i = h.config,
          j = h.getFromEnv('chartWidth'),
          k = h.getFromEnv('chartHeight'),
          l = i.canvasLeft,
          m = i.width - (i.canvasRight || 0),
          n = h.getFromEnv('smartLabel'),
          o = g.config,
          p = o.chartMarginLeft,
          q = o.chartMarginRight,
          r = o.chartMarginTop,
          s = o.alignLegendWithCanvas,
          t = g.getSortedLegendItems(),
          u = t.length,
          v = o.legendPadding,
          w = i.canvasMarginRight,
          x = i.canvasMarginLeft,
          y = h.getChildren('yAxis'),
          z = y && y[0].config.isVertical ? y : h.getChildren('xAxis'),
          A = z && z[0],
          B = z && z[1],
          C = A && A.config || {},
          D = B && B.config || {},
          E = C.nameMaxW,
          F = D.nameMaxW,
          G = C.name && C.name.style || {},
          H = D.name && D.name.style || {},
          I = C.axisName || BLANKSTRING,
          J = D.axisName || BLANKSTRING,
          K = i.canvasWidth - i.canvasMarginLeft - i.canvasMarginRight;
      return o.paddingBottom = i.height - i.canvasBottom, n.useEllipsesOnOverflow(i.useEllipsesWhenOverflow), n.setStyle(G), e = n.getOriSize(I), n.setStyle(H), f = n.getOriSize(J), K < v && (o.padding = v = K = 0), (e || f) && (c = pluckNumber(e.height, 0) > pluckNumber(f.height, 0) ? (d = E) && e.width : (d = F) && f.width), K = s ? K : j - (c + r > k - a ? 2 * d + q + p + w + x : q + p + x + w), o.showLegend && 0 !== u ? (o.x = (l - p - m + q) / 2, b = g.setDimension({
        width: K,
        height: a
      }).height) : (b = 0, o.height = 0, o.width = 0), {
        bottom: b,
        right: 0
      };
    }
  }, {
    key: "_placeLegendBlockRight",
    value: function _placeLegendBlockRight(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          j,
          k,
          l,
          m = this,
          n = m.config,
          o = m.getFromEnv('chart'),
          p = o.config,
          q = o.getFromEnv('smartLabel'),
          r = o.getChildren('canvas')[0].config.canvasBorderThickness || 0,
          s = n.textPadding,
          t = n.title.padding,
          u = n.oriSymbolPadding,
          v = n.legendPadding,
          w = n.legendScale,
          x = m.getStateCosmetics('default'),
          y = parseInt(x.text['font-size'], 10),
          z = p.canvasHeight,
          A = 2 * z,
          B = 0,
          C = n.padding,
          D = 2 * C,
          E = {
        width: D,
        height: D
      },
          F = {},
          G = !1,
          H = m.getSortedLegendItems(),
          I = H.length,
          J = 0;
      if (n.initialItemY = 0, n.initialItemX = 0, a -= D + v, a < v && (n.padding = v = a = 0), e = y + 1, 0 >= e && (e = 1), e *= w, u *= w, e = mathMin(e, a), 0 >= e && (u = e = 0), n.symbolPadding = u, n.symbolWidth = e, n.legendHeight = f = e + 2 * u, n.rowHeight = mathMax(parseInt(x.text['line-height'], 10) || 12, f), b = v + n.borderWidth / 2 + r, d = a - f - v - s, 0 > d && (d = 0), q.useEllipsesOnOverflow(p.useEllipsesWhenOverflow), q.setStyle(extend2({}, x.text)), !n.showLegend || 0 === I) F.right = 0, n.height = 0, n.width = 0;else {
        for (J = 0; J < I; J += 1) {
          if (l = H[J], g = l.config || (l.config = {}), k = g, h = g.name = parseUnsafeString(k.label), g._legendX = 0, g._legendY = E.height, 0 === k.enabled || !1 === k.enabled || h === BLANKSTRING) {
            g.enabled = 0;
            continue;
          } else g.enabled = 1;

          G = !0, 0 === d ? (E.height += g._legendH = f, g.name = BLANKSTRING, g._totalWidth = e + u) : (c = q.getSmartText(h, d, A), g.name = c.text, c.tooltext && (g.originalText = c.tooltext), c.height < f && (g._legendTestY = (f - c.height) / 2), g._totalWidth = e + u + s + c.width + v, E.height += g._legendH = mathMax(c.height, f), B = mathMax(c.width, B));
        }

        n.validLegendItem = G, G ? (n.itemWidth = B + f + v + s, n.width = n.itemWidth + D, n.title.oriText !== BLANKSTRING && (q.setStyle(n.title.style), c = q.getSmartText(n.title.oriText, a, A), n.title.text = c.text, c.tooltext && (n.title.originalText = c.tooltext), j = c.width + D, n.width < j && (n.initialItemX = (j - n.width) / 2, n.width = j), n.initialItemY = c.height + t, E.height += n.initialItemY), n.height = n.totalHeight = E.height, b = mathMin(n.width + b, a), F.right = b + v, n.isActive = !0, n.enabled = !0) : (n.enabled = !1, n.width = 0, F.right = 0);
      }
      return F;
    }
  }, {
    key: "postSpaceManager",
    value: function postSpaceManager() {
      var a = this,
          b = a.config,
          c = b.legendPos,
          d = a.getFromEnv('chart'),
          e = d.config.canvasHeight;
      c === POSITION_RIGHT && (b.height > e ? (b.height = e, b.scroll.enabled = !0, b.scroll.flatScrollBars = b.flatScrollBars, b.scroll.scrollBar3DLighting = b.scrollBar3DLighting, b.width += (b.scroll.scrollBarWidth = 10) + (b.scroll.scrollBarPadding = 2)) : b.scroll.enabled = !1);
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(Legend.prototype), "configureAttributes", this).call(this, a);

      var b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.config,
          i = g.getFromEnv('chart'),
          j = i.config,
          k = g.getFromEnv('style'),
          l = i.getFromEnv('chart-attrib'),
          m = i.config.is3D,
          n = g.getFromEnv('color-manager'),
          o = m ? chartPaletteStr.chart3D : chartPaletteStr.chart2D,
          p = h.interactiveLegend = !1 !== i.hasInteractiveLegend && !!pluckNumber(l.interactivelegend, 1),
          q = pluckNumber(l.useroundedges, 0),
          r = k.outCancolor,
          s = a.style && a.style.text,
          t = pluck(l.legenditemfont, s && s['font-family'], k.outCanfontFamily),
          u = pluckNumber(l.legendiconscale, 1),
          v = pluckFontSize(l.legenditemfontsize, s && s['font-size'], k.fontSize) + 'px',
          w = pluck(l.legenditemfontcolor, s && s.color, r).replace(/^#?([a-f0-9]+)/ig, '#$1'),
          x = getFirstColor(pluck(l.legenditemhoverfontcolor, w));
      h.isActive = !1, h.chartMarginTop = j.origMarginTop, h.chartMarginRight = j.origMarginRight, h.chartMarginBottom = j.origMarginBottom, h.chartMarginLeft = j.origMarginLeft, h.reverselegend = pluckNumber(l.reverselegend, 0), h.showLegend = pluckNumber(l.showlegend, !i.dontShowLegendByDefault, 1), b = setLineHeight({
        fontSize: v
      }), h.legendPos = pluck(l.legendposition, i.legendposition, a.legendPosition, POSITION_BOTTOM).toLowerCase(), h.numColumns = pluckNumber(l.legendnumcolumns, 0), h.xL = h.yL = 0, (0 >= u || 5 < u) && (u = 1), h.drawCustomLegendIcon = pluckNumber(l.drawcustomlegendicon, a.drawcustomlegendicon, 0), h.legendScale = u, h.legendPadding = pluckNumber(l.legendpadding, 7), h.alignLegendWithCanvas = pluckNumber(a.alignlegendwithcanvas, j.alignLegendWithCanvas), h.title.style = {
        fontFamily: pluck(l.legendcaptionfont, t),
        fontSize: pluckFontSize(l.legendcaptionfontsize, k.fontSize) + 'px',
        color: pluck(l.legendcaptionfontcolor, r).replace(/^#?([a-f0-9]+)/ig, '#$1'),
        fontWeight: styleValueMap.fontWeight[pluckNumber(l.legendcaptionfontbold, 1)] || BLANKSTRING
      }, f = l.legendcaptionalignment ? l.legendcaptionalignment.toLowerCase() : TEXT_ANCHOR_MAP.center, h.title.align = TEXT_ANCHOR_MAP[f] || TEXT_ANCHOR_MAP.center, h.title.style['text-anchor'] = h.title.align, h.padding = 4, c = pluck(l.legendbordercolor, n.getColor(o.legendBorderColor)), d = h.borderAlpha = pluckNumber(l.legendborderalpha, 100), h.borderColor = convertColor(c, d), h.borderWidth = pluckNumber(l.legendborderthickness, a.legendborderthickness, !q || l.legendbordercolor ? 1 : 0), h.borderRadius = pluckNumber(q, 0), h.backgroundAlpha = e = pluckNumber(l.legendbgalpha, a.legendbgalpha, 100), h.backgroundColor = convertColor(pluck(l.legendbgcolor, n.getColor(o.legendBgColor)), e), h.symbol3DLighting = !!pluckNumber(l.use3dlighting, l.useplotgradientcolor, 1), h.shadow = !!pluckNumber(l.legendshadow, 1), h.shadow && (h.shadow = {
        enabled: h.shadow,
        opacity: mathMax(d, e) / 100
      }), h.prevReversed = !!pluckNumber(h.reversed, 0), h.reversed = !!pluckNumber(l.reverselegend, 0), h.lineWidth = pluckNumber(l.linethickness, 2), h.borderRadius = pluckNumber(l.legendborderradius, q ? 3 : 0), h.legendAllowDrag = !!pluckNumber(l.legendallowdrag, 0), h.title.oriText = parseUnsafeString(getFirstValue(l.legendcaption, BLANKSTRING)), h.legendScrollBgColor = getFirstColor(pluck(l.legendscrollbgcolor, l.scrollcolor, n.getColor('altHGridColor'))), h.legendScrollBarColor = pluck(l.legendscrollbarcolor, c), h.legendScrollBtnColor = pluck(l.legendscrollbtncolor, c), h.minimiseWrappingInLegend = pluckNumber(l.minimisewrappinginlegend, 0), h.flatScrollBars = pluckNumber(l.flatscrollbars, 0), h.scrollBar3DLighting = pluckNumber(l.scrollbar3dlighting, 1), h.orderReversed = !1, g.setStateCosmetics('hidden', {
        symbol: {
          fill: convertColor(pluck(l.legenditemhiddencolor, 'cccccc').replace(/^#?([a-f0-9]+)/ig, '#$1')),
          stroke: convertColor(pluck(l.legenditemhiddencolor, 'cccccc').replace(/^#?([a-f0-9]+)/ig, '#$1'))
        },
        text: {
          fill: convertColor(pluck(l.legenditemhiddencolor, 'cccccc').replace(/^#?([a-f0-9]+)/ig, '#$1'))
        }
      }), g.setStateCosmetics('default', {
        text: {
          fill: convertColor(w),
          "font-family": t,
          cursor: p ? preDefStr.POINTER : 'default',
          "font-size": v,
          "line-height": b,
          "vertical-align": POSITION_TOP,
          "text-anchor": POSITION_START,
          direction: 'rtl' === j.textDirection ? 'rtl' : 'initial',
          "font-weight": styleValueMap.fontWeight[pluckNumber(l.legenditemfontbold, 0)] || BLANKSTRING
        },
        symbol: {
          bgColor: pluck(l.legendiconbgcolor),
          cursor: p ? preDefStr.POINTER : 'default',
          borderColor: pluck(l.legendiconbordercolor),
          bgAlpha: pluck(l.legendiconbgalpha, l.legendiconalpha, 100),
          borderAlpha: pluck(l.legendiconborderalpha, l.legendiconalpha, 100),
          borderThickness: pluckNumber(l.legendiconborderthickness),
          startAngle: pluckNumber(l.legendiconstartangle, 45),
          sides: pluckNumber(l.legendiconsides, a.legendiconsides, 4)
        }
      }), g.setStateCosmetics('hover', function (a, b) {
        return b.hasState('hidden') || (!a.text && (a.text = {}), a.text.fill = convertColor(x.replace(/^#?([a-f0-9]+)/ig, '#$1')), a.text.cursor = 'inherit'), a;
      }), h.legendAllowDrag && !h._dragEvtListenerBinded ? (g.addEventListener('fc-dragstart', h.handlers.dragstart), g.addEventListener('fc-dragmove', h.handlers.dragmove), h._dragEvtListenerBinded = !0) : (g.removeEventListener('fc-dragstart', h.handlers.dragstart), g.removeEventListener('fc-dragmove', h.handlers.dragmove), h._dragEvtListenerBinded = !1);
    }
  }, {
    key: "getLegendState",
    value: function getLegendState() {
      return this._legendState;
    }
  }, {
    key: "hasState",
    value: function hasState(a) {
      var b,
          c,
          d = this.getLegendState();

      for (b = 0, c = d.length; b < c; b++) {
        if (d[b] === a) return !0;
      }

      return !1;
    }
  }, {
    key: "setLegendState",
    value: function setLegendState(a, b) {
      this.hasState(a) || (b ? this._legendState.push(a) : this._legendState.unshift(a)), this.asyncDraw();
    }
  }, {
    key: "removeLegendState",
    value: function removeLegendState(a) {
      var b,
          c,
          d = 1;
      if (a) for (b = 0, c = this._legendState.length; b < c && d; b++) {
        a === this._legendState[b] && (this._legendState.splice(b, 1), d = 0);
      } else this._legendState.length = 0;
      this.asyncDraw();
    }
  }, {
    key: "setStateCosmetics",
    value: function setStateCosmetics(a, b) {
      this._stateCosmetics[a] = b;
    }
  }, {
    key: "removeStateCosmetics",
    value: function removeStateCosmetics(a) {
      delete this._stateCosmetics[a];
    }
  }, {
    key: "getStateCosmetics",
    value: function getStateCosmetics(a) {
      return this._stateCosmetics[a];
    }
  }, {
    key: "hide",
    value: function hide() {
      var a = this,
          b = a.getFromEnv('chart'),
          c = b.getChildContainer('legendGroup');
      c && c.hide();
    }
  }]);

  return Legend;
}(ComponentInterface);

export default Legend;